import { Injectable } from '@angular/core';
import {
  HttpEvent, HttpInterceptor, HttpHandler, HttpRequest
} from '@angular/common/http';
import { CustomOktaAuthService } from './oktaauth.service';
import { from } from 'rxjs';
import { Router } from '@angular/router';
import { Logger } from '../shared/logger/logger.component';


@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private authService: CustomOktaAuthService,
    private router: Router,
    private logger: Logger
  ) { }
  intercept(req: HttpRequest<any>, next: HttpHandler) {
    return from(this.handleAccess(req, next));
  }

  private async handleAccess(request: HttpRequest<any>, next: HttpHandler): Promise<HttpEvent<any>> {

    try {
      const accessToken = await this.authService.getAccessToken();
      this.authService.refreshToken('auth interceptor ' + request.url)
      if (!accessToken) {
        this.router.navigate(['/logout']);
      }

      // console.log('Interceptor accessToken: ', accessToken.accessToken);

      request = request.clone({
        setHeaders: {
          Authorization: 'Bearer ' + accessToken.accessToken
        }
      });

      return next.handle(request).toPromise();
    } catch {
      // console.log('Access Token in handleAccess');
      this.logger.log('Access Token error in handleAccess');
    }

    return null;
  }

}

